<script setup lang="ts">
import { cn } from '@lib/utils';
import { PinInputInput, type PinInputInputProps, useForwardProps } from 'reka-ui';
import { computed, type HTMLAttributes } from 'vue';

const props = defineProps<PinInputInputProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;
  return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <PinInputInput
    v-bind="forwardedProps"
    :class="
      cn(
        'relative flex min-w-0 items-center justify-center border border-input bg-background px-0 text-center text-lg transition-all focus:relative focus:z-10 focus:outline-none focus:ring-2 focus:ring-ring',
        props.class,
      )
    "
  />
</template>
